import { workspaceMedProjectMembersPath, workspaceMedProjectModulesPath, workspaceMedProjectNoticesPath, workspaceMedProjectQuickEntriesPath, workspaceMedProjectSettingPath } from '../medProjectWorkspacePaths';

/**
 * WorkspaceSider / 移动抽屉：与 AppSider 医项目详情侧栏条目一致。
 * 「项目信息」：`/medproject/projects/:projectId/info`（`projectId` 为 `new` 时为「新增项目」，仅该项可用）。
 *
 * @param {string} projectId
 * @param {number} activitiesModuleId
 * @param {{ isCreateMode?: boolean }} [options]
 * @returns {{ key: string, label: string, disabled?: boolean, icon: string }[]}
 */
export function buildMedProjectWorkspaceMenuEntries(projectId, activitiesModuleId, options = {}) {
    const { isCreateMode = false } = options;
    const moduleKey = activitiesModuleId || 0;

    if (isCreateMode) {
        // 新增项目仅「项目信息」可用；实际路径为 `/medproject/projects/new` 本身（由 WorkspaceLayout 的 index 路由渲染表单）
        return [
            { key: `/medproject/projects/${projectId}`, label: '项目信息', icon: 'bi bi-info-circle' },
            { key: `/medproject/projects/${projectId}/modules/${moduleKey}`, label: '模块管理', disabled: true, icon: 'bi bi-grid' },
            { key: `/medproject/projects/${projectId}/quick-entries`, label: '快捷入口', disabled: true, icon: 'bi bi-lightning-charge' },
            { key: `/medproject/projects/${projectId}/members`, label: '成员管理', disabled: true, icon: 'bi bi-people' },
            { key: `/medproject/projects/${projectId}/notices`, label: '通知管理', disabled: true, icon: 'bi bi-bell' },
            { key: `/medproject/projects/${projectId}/setting`, label: '页面设置', disabled: true, icon: 'bi bi-gear' },
        ];
    }

    return [
        { key: `/medproject/projects/${projectId}/info`, label: '项目信息', icon: 'bi bi-info-circle' },
        { key: workspaceMedProjectModulesPath(projectId, moduleKey), label: '模块管理', icon: 'bi bi-grid' },
        { key: workspaceMedProjectQuickEntriesPath(projectId), label: '快捷入口', icon: 'bi bi-lightning-charge' },
        { key: workspaceMedProjectMembersPath(projectId), label: '成员管理', icon: 'bi bi-people' },
        { key: workspaceMedProjectNoticesPath(projectId), label: '通知管理', icon: 'bi bi-bell' },
        { key: workspaceMedProjectSettingPath(projectId), label: '页面设置', icon: 'bi bi-gear' },
    ];
}
